<template>
    <div class="title-group relative">
        <el-tooltip class="item" effect="dark" placement="top-start" :content="tips">
            <span class="el-icon-question pointer ml4"></span>
        </el-tooltip>
        <span class="text-bold pl2 pr6">{{title}}（{{count}}）</span>
        <el-button type="danger" size="mini" class="clear-btn" @click="handleClear" v-if="count>0" plain>清空</el-button>
        <div class="extra-con inline-block" v-if="extraTips">
            <el-tooltip class="item" effect="dark" placement="top-start" :content="extraTips">
                <span class="el-icon-question pointer ml4"></span>
                <div slot="content">
                    <p class="tal" style="max-width: 250px;">{{extraTips}}</p>
                </div>
            </el-tooltip>
            <slot></slot>
        </div>
        <div class="inline-block extra-con2">
            <slot name="content"></slot>
        </div>

    </div>
</template>

<script>
    export default {
        name: "TitleGroup",
        props:{
            title:String,
            count:[String,Number],
            tips:String,
            extraTips:String,
        },
        methods:{
            handleClear(){
                this.$emit('clear');
            },
        }
    }
</script>

<style scoped>
    .clear-btn{
        padding: 2px 5px;
    }
    .extra-con{
        position: absolute;
        left: 200px;
    }
    .extra-con2{
        position: absolute;
        left: 400px;
    }
</style>
